module.exports = __webpack_public_path__ + "static/media/bar3.8369f543.svg";